import { getWidgetSpecificIsVisible } from "@utils/index";
import React from "react";
import { getWidgetSpecificProps } from "@utils/index";

import { connect } from "react-redux";
import { HeadingWrapper, MainContainer } from "./styles";
import { useOnload } from "@utils/useOnLoad";
import Badge from "@components/common/badge";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const PageHeading = (props: any) => {
  const {
    text,
    is_visible,
    styles,
    mStyles,
    actions,
    isPrefilled,
    prefilledText,
    badge,
    hideOnDesktop
  } = props;

  const { on_load } = actions || {};

  useOnload({ on_load });

  const showText = isPrefilled ? prefilledText : text;

  return is_visible ? (
    <HeadingWrapper hideOnDesktop={hideOnDesktop}>
      {badge?.text && (
        <div style={{ marginRight: "1rem" }}>
          <Badge
            is_visible={badge?.is_visible ?? true}
            text={badge?.text}
            type={badge?.type}
            image={badge?.image?.imgSrc}
            styles={{ marginBottom: "1rem" }}
          />
        </div>
      )}
      <MainContainer
        className="page-heading"
        dangerouslySetInnerHTML={{ __html: showText }}
        styles={styles}
        mStyles={mStyles}
      />
    </HeadingWrapper>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(PageHeading);
